<div class="flex items-center gap-3 mb-4">
  @if (activeSlideIndex > 0 && !isPending) {
    <button
      (click)="goBack()"
      class="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors cursor-pointer border-none bg-transparent"
    >
      <i class="pi pi-arrow-left text-surface-600 dark:text-surface-300"></i>
    </button>
  }
  <span class="text-sm text-surface-400">
    Step {{ activeSlideIndex + 1 }} of 2
  </span>
</div>

<zaeper-content-slider>
  <!-- Slide 0: Registration form -->
  <zaeper-content-slide [centered]="false">
    <div class="flex flex-col gap-6">
      <div class="text-center flex flex-col items-center gap-3">
        <div class="flex-shrink-0 w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <i class="pi pi-user text-2xl text-primary"></i>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-surface-900 dark:text-surface-0 mb-1">Create your developer account</h3>
          <p class="text-sm text-surface-500">Set up your profile to get started.</p>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label for="displayName" class="font-medium">Display Name *</label>
        <input id="displayName"
               type="text"
               pInputText
               [(ngModel)]="displayName"
               placeholder="Your developer or company name" />
      </div>

      <div class="flex flex-col gap-2">
        <label for="slug" class="font-medium">Slug *</label>
        <input id="slug"
               type="text"
               pInputText
               autocomplete="off"
               [ngModel]="slug"
               (ngModelChange)="onSlugChange($event)"
               placeholder="acme" />
        <small class="text-surface-500">Your namespace for packages, e.g. <code>{{ slug || "acme" }}/weather</code>. It can't be changed later.</small>
        @if (slugMessage) {
          <small [class.text-red-500]="slugStatus === 'invalid' || slugStatus === 'taken' || slugStatus === 'reserved'"
                 [class.text-green-600]="slugStatus === 'available'"
                 [class.text-surface-500]="slugStatus === 'checking'">{{ slugMessage }}</small>
        }
      </div>
      <div class="flex flex-col gap-2">
        <label for="website" class="font-medium">Website</label>
        <input id="website"
               type="text"
               pInputText
               [(ngModel)]="website"
               placeholder="https://example.com (optional)" />
      </div>

      <div class="flex items-start gap-3">
        <p-checkbox [(ngModel)]="termsAccepted"
                    [binary]="true"
                    inputId="termsAccepted" />
        <label for="termsAccepted">
          I accept the Developer Terms of Service and agree to the platform guidelines. *
        </label>
      </div>

      @if (errorMessage) {
        <div class="text-red-500 text-sm">{{ errorMessage }}</div>
      }

      <p-button label="Continue"
                icon="pi pi-arrow-right"
                iconPos="right"
                [rounded]="true"
                [disabled]="!isRegistrationFormValid || isSubmitting"
                [loading]="isSubmitting"
                (onClick)="onRegister()"
                styleClass="w-full" />
    </div>
  </zaeper-content-slide>

  <!-- Slide 1: Payment & subscription -->
  <zaeper-content-slide [centered]="false">
    <div class="flex flex-col gap-6">
      <div class="text-center flex flex-col items-center gap-3">
        <div class="flex-shrink-0 w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <i class="pi pi-credit-card text-2xl text-primary"></i>
        </div>
        <div>
          <h3 class="text-lg font-semibold text-surface-900 dark:text-surface-0 mb-1">Activate Developer License</h3>
          <p class="text-sm text-surface-500">Enter your payment details to activate your yearly developer license.</p>
        </div>
      </div>

      <div class="p-4 rounded-xl bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
        <div class="flex items-center justify-between">
          <div>
            <div class="font-semibold text-surface-900 dark:text-surface-0">Developer License</div>
            <div class="text-sm text-surface-500">Yearly subscription</div>
            <app-licence-price />
          </div>
          <div class="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <i class="pi pi-verified text-primary"></i>
          </div>
        </div>
      </div>

      @if (paymentErrorMessage) {
        <div class="p-3 bg-red-50 text-red-700 rounded-lg text-sm">
          {{ paymentErrorMessage }}
        </div>
      }

      <div #paymentElement class="min-h-[200px]">
        @if (isLoadingPayment) {
          <div class="flex items-center justify-center h-[200px] text-surface-400 dark:text-surface-500">
            <i class="pi pi-spinner pi-spin text-2xl"></i>
          </div>
        }
      </div>

      <p-button label="Activate License"
                icon="pi pi-lock"
                [rounded]="true"
                [loading]="isConfirmingPayment"
                [disabled]="isLoadingPayment || !!paymentErrorMessage"
                (onClick)="onConfirmPayment()"
                styleClass="w-full" />
    </div>
  </zaeper-content-slide>
</zaeper-content-slider>
